import { gql } from '@apollo/client';
import type { ICreatedUser, IEnrollmentFormInfo, IInviteAcceptForm, Invite, InviteForm } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLInvitesRequester {
  public getInviteInfo = (token: string): Promise<IEnrollmentFormInfo> => {
    const queryResult = graphQLRequester
      .query<{ inviteInfo: IEnrollmentFormInfo }>({
        query: gql`
        query getInviteInfo($token: String!) {
          inviteInfo(token: $token) {
            invite {
              emailAddress
              fleetId
            },
            occupations {
              key
              value
            }
          }
        }
      `,
        variables: { token },
      })
      .then((response) => response.inviteInfo);

    return queryResult;
  };

  public acceptInvite = (acceptForm: IInviteAcceptForm, token: string): Promise<ICreatedUser> => {
    const mutationResult = graphQLRequester
      .mutate<{ acceptInvite: ICreatedUser }>({
        mutation: gql`
        mutation acceptInvite($input: IInviteAcceptForm!, $token: String!) {
          acceptInvite(input: $input, token: $token) {
            id
            fullName
          }
        }
      `,
        variables: {
          input: acceptForm,
          token,
        },
      })
      .then((response) => response.acceptInvite);

    return mutationResult;
  };

  public getPendingInvites = (): Promise<Invite[]> => {
    const queryResult = graphQLRequester
      .query<{ pendingInvites: Invite[] }>({
        query: gql`
        query getPendingInvites {
          pendingInvites {
            emailAddress
            creationDate
            token
            fleetId
            creatorId
            role
            groupsRestriction
            customPermissions
            groups {
              id
              name
              path
            }
          }
        }
      `,
      })
      .then((response) => response.pendingInvites);

    return queryResult;
  };

  public sendInvites = (invites: InviteForm[]): Promise<any> => {
    const mutationResult = graphQLRequester
      .mutate<any>({
        mutation: gql`
          mutation sendInvites($input: [InviteForm]!) {
            sendInvites(input: $input) {
              invites {
                status
                invites {
                  email_address
                  token
                }
              }
            }
          }
        `,
        variables: {
          input: invites,
        },
      })
      .then((response) => {
        if (response.errors) {
          throw new Error(JSON.stringify(response.errors));
        }
      });

    return mutationResult;
  };

  public deleteInvite = (token: string): Promise<boolean> => {
    const mutationResult = graphQLRequester.mutate<boolean>({
      mutation: gql`
        mutation deleteInvite($token: String!) {
          deleteInvite(token: $token)
        }
      `,
      variables: {
        token,
      },
    });

    return mutationResult;
  };
}

export default GraphQLInvitesRequester;
